import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  const whatsappUrl = 'https://wa.me/5493417453398?text=Hola%2C+quiero+consultar+por+El+Matambrito+🍖';
  return <motion.div initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 200,
    damping: 20
  }} className="fixed bottom-6 right-6 z-50 group" data-id="element-454">
      <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-white text-gray-900 px-4 py-2 rounded-lg shadow-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-455">
        Hola, quiero consultar por El Matambrito 🍖
        <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-white rotate-45" data-id="element-456"></div>
      </div>
      <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20bd5a] transition-colors duration-300 hover:scale-110 transform" aria-label="Contactar por WhatsApp" data-id="element-457">
        <MessageCircle className="w-8 h-8" data-id="element-458" />
      </a>
    </motion.div>;
}